export default () => ({
  id: null,
  title: null,
  content: null,
  link_url: null,
  package: null,
  creator: null,
  responses: [],
  responded_users: [],
  response_percentage: null,
  created_at: null,
  sent_to: null
})
